import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGovernment: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="government, bank, building"><path d="M14.75 12V20" stroke="currentColor" strokeWidth="1.5"/><path d="M9.25 12V20" stroke="currentColor" strokeWidth="1.5"/><path d="M3.75 19.5V13C3.75 8.44365 7.44365 4.75 12 4.75C16.5563 4.75 20.25 8.44365 20.25 13V19.5" stroke="currentColor" strokeWidth="1.5"/><path d="M12 4.5V0.75H14.25V2.25H12.5" stroke="currentColor" strokeWidth="1.5"/><path d="M2 20.25H22" stroke="currentColor" strokeWidth="1.5"/><path d="M2 11.75H22" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconGovernment;
